<template>
  <v-container class="pt-0 personal" fluid>
    <v-container class="header-container">
      <h2 class="notranslate pl-2 ">
        {{ $t("personal.alt_title") }}
      </h2>
      <div :class="isSticky ? 'sticky-header' : ''">
        <v-row class="mt-5" :class="isSticky ? 'sticky-child' : ''">
          <v-col sm="5" md="4" lg="3" xl="3" cols="12">
            <v-text-field
              v-model="search"
              :placeholder="$t('buscar')"
              hide-details
              background-color="white lighten"
              prepend-inner-icon="mdi-magnify"
              v-on:keydown="onChange"
            />
          </v-col>

          <v-col sm="5" md="4" lg="3" xl="3" cols="12" class="ml-auto">
            <v-select
              v-model="filtro"
              background-color="white lighten"
              placeholder="Todas"
              item-text="noLinea"
              item-value="_id"
              label="Filtrar"
              hide-details
              prefix="Categoría: "
              :items="tags"
            />
          </v-col>
        </v-row>
      </div>
    </v-container>
    <v-container>
      <v-layout row wrap v-for="tag in tags" :key="tag" v-if="sectionShouldShow(tag)">
        <v-flex data-aos="fade-up" xs12 sm12 md12 lg12 xl12>
          <h5 class="mt-2 mb-2 px-3">-{{ tag || "Otros" }}</h5>
        </v-flex>
        <v-flex
          class="align-center d-flex xs12 sm6 md6 lg6 xl6 "
          v-for="(personal, index) in onChange(search, orden, filtro, tag)"
          :key="index"
        >
          <WorkerCell
            :workerDetails="showInfo"
            data-aos="fade-up"
            :worker="personal"
            style="margin-bottom:40px"
          />
        </v-flex>
        <div
          class="d-flex align-center justify-center"
          style="height:200px; width:100%"
          v-if="onChange(search, orden, filtro, tag).length == 0"
        >
          <h6 class="light">No hay Información para mostrar</h6>
        </div>
      </v-layout>
    </v-container>
    <WorkerDetails :worker="selectedWorker" :open="workerDrawer" :close="closeDrawer" />
    <ScrollToTop />
  </v-container>
</template>
<script>
import { WorkerCell } from "../components/Lists";
import { WorkerDetails } from "../components/Form";

export default {
  name: "Personal",
  //{v-container, v-row, v-col, v-img, v-layout }
  components: {
    WorkerCell,
    WorkerDetails,
    ScrollToTop: () => import(/* webpackPrefetch: true */ "../components/Form/scrollToTop.vue")
  },
  data: () => ({
    isSticky: false,
    search: "",
    tags: [],
    filtro: "",
    orden: "",
    filters: [],
    workerDrawer: false,
    selectedWorker: null
  }),
  computed: {
    personal: function() {
      const { personal, retired } = this.$info.about;
      var sinJubilados = [];
      personal.forEach((worker, i) => {
        if (retired.findIndex(retired => retired.id === worker.id) < 0) {
          sinJubilados.push(worker);
        }
      });

      return [...sinJubilados];
    }
  },
  created: function() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  beforeMount: function() {
    this.filters = [
      ...new Set(
        this.$info.about.personal.map(worker => {
          return worker.position.toLowerCase().replace(/^\w/, c => c.toUpperCase());
        })
      )
    ];
    const leShit = [
      ...new Set(
        this.$info.about.personal.map(worker =>
          (worker.lastName + " " + worker.name + ".jpg")
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace("dr. ", "")
            .replace("dra. ", "")
            .replace(/ /g, "_")
        )
      )
    ];
    this.tags = [
      ...new Set(
        this.$info.about.personal.map(worker =>
          worker.tag.toLowerCase().replace(/^\w/, c => c.toUpperCase())
        )
      )
    ];
    this.tags.unshift("Todos");
    leShit.sort(function(a, b) {
      return a.localeCompare(b);
    });
  },
  methods: {
    handleScroll(event) {
      const breakpoint = this.$vuetify.breakpoint.smAndDown ? 125 : 160;
      // console.warn(window.scrollY);
      if (window.scrollY > breakpoint) {
        this.isSticky = true;
      } else this.isSticky = false;
    },
    sectionShouldShow(tag) {
      if (tag != "Todos") {
        if (this.filtro == "Todos" || this.filtro.length == 0) {
          return true;
        } else {
          return tag.toLowerCase() === this.filtro.toLowerCase();
        }
      } else {
        return false;
      }
    },
    showInfo(worker, state) {
      this.selectedWorker = worker;
      this.workerDrawer = state;
    },
    closeDrawer() {
      this.workerDrawer = false;
    },
    onChange(search, orden, filtro, tag) {
      const filteredByName = this.personal.filter(worker =>
        (worker.name + " " + worker.lastName)
          .toUpperCase()
          .includes(search.toString().toUpperCase())
      );

      const filterTag = filteredByName.filter(
        worker => worker.tag.toLowerCase() === tag.toLowerCase()
      );

      const applyedFilter = filterTag.filter(worker => {
        if (filtro !== "Todos" && filtro.length > 0) {
          return worker.tag.toLowerCase() === this.filtro.toLowerCase();
        } else {
          return true;
        }
      });

      return applyedFilter;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/global";
.personal {
  position: relative;
  margin-top: 100px;
}
.header-container {
  position: relative;
  min-height: 180px;
}
.sticky-header {
  background-color: white;
  position: fixed;
  top: 52px;
  z-index: 200;
  left: 0;
  width: 100%;
}

.sticky-child {
  margin: 0 auto;
  width: 1185px;
}

@media (max-width: 1185px) {
  .sticky-child {
    width: 900px;
  }
}
@media (max-width: 960px) {
  .personal {
    margin-top: 75px;
  }
  .sticky-child {
    margin: 0 !important;
    top: 39px;
    left: 0;
    width: 100%;
  }
}

@media (max-width: 600px) {
  .header-container {
    position: relative;
    min-height: 220px;
  }
}

// $screen-xs-min
// $screen-sm-min
// $screen-md-min
// $screen-lg-min
// $screen-xl-min
</style>
